import React, {Component} from 'react';
import { SelectList } from '../FormUI';

export default class DoctorTypeList extends Component{
    render(){
        let {options, isCreatable, ...props} = this.props;
        return(
            <SelectList 
                options={[
                    {label:'General Practitioner', value:'General Practitioner'},
                    {label:'Endocrinologist', value:'Endocrinologist'},
                    {label:'Family physician', value:'Family physician'},
                    {label:'Nurse practitioner', value:'Nurse practitioner'},
                    {label:'Obstetrician', value:'Obstetrician'},
                    {label:'Orthopedic surgeon', value:'Orthopedic surgeon'},
                    {label:'Pediatrician', value:'Pediatrician'},
                    {label:'Physician’s Assistant', value:'Physician’s Assistant'},
                    {label:'Physiotherapist', value:'Physiotherapist'},
                    {label:'Vascular Surgeon', value:'Vascular Surgeon'},
                    {label:'Other', value:'Other'}
                ]}                
                simpleValue={true}
                isCreatable={false}
                promptTextCreator={(label) => 'Other: ' + label}
                {... props}         
            />
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/selectlists/DoctorTypeList.js